import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/geist';
import './index.css';
import { StaffApp } from './App';
import { AdminApp } from './admin/AdminApp';
import { CustomerApp } from './customer/CustomerApp';
import { VetApp } from './vet/VetApp';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

const host = window.location.hostname;
const path = window.location.pathname;

const isPlatformHost =
  host === 'app.kennel.app' || host === 'kennel-api.jordan-20b.workers.dev' || host === 'localhost';

// Platform admin surface: /admin/* on the platform host.
const isAdminPath = isPlatformHost && path.startsWith('/admin');

// Vet portal: vet.kennel.app (platform-level, not a tenant subdomain).
// Local dev: vet.localhost. Workers preview deploys use a query param for
// QA — but in prod the host is the authoritative router.
const isVetHost = host === 'vet.kennel.app' || host === 'vet.localhost';

let App: React.ComponentType;
if (isVetHost) {
  App = VetApp;
} else if (isAdminPath) {
  App = AdminApp;
} else if (isPlatformHost) {
  App = StaffApp;
} else {
  App = CustomerApp;
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
